enum Modals {
  changeEmail = 'changeEmail',
  checkout = 'checkout',
  newCheckout = 'newCheckout',
}

export default {
  [Modals.changeEmail]: {
    component: 'LazyChangeEmailAddress',
    props: { transition: { name: 'slide-bottom' } },
  },
  [Modals.checkout]: {
    component: 'LazyPaymentForm',
    props: { transition: { name: 'slide-bottom' } },
  },
  [Modals.newCheckout]: {
    component: 'LazyNewCheckoutModal',
    props: { transition: { name: 'slide-bottom' } },
  },
};
